/* styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal } from '../Typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _14 = "._p03c16c2 a:active{color:var(--ds-link-pressed,#05c)}";
const _13 = "._bpspni7l a{font-weight:600}";
const _12 = "._19tb1j6v a{font-size:1rem}";
const _11 = "._43ds14q2 a{color:var(--ds-link,#0c66e4)}";
const _10 = "._1g45ugt7 a:focus-visible{outline:2px solid var(--ds-border-focused,#388bff)}";
const _9 = "._1wij14y2 a:focus-visible{border-radius:5px}";
const _8 = "._dd6hidpf ol ol, ._1p7uidpf ol ul, ._orjkidpf ul ol, ._xmwmidpf ul ul{margin-bottom:0}";
const _7 = "._1wmc1k8s li, ._zcqx1k8s p, ._1qza1k8s ul{line-height:1.5rem}";
const _6 = "._1foz1j6v li, ._q7gq1j6v p, ._zo641j6v ul{font-size:1rem}";
const _5 = "._8agh1rkn ul li{margin:0 0 var(--ds-space-075,6px) 0}";
const _4 = "._12ml18yu ol, ._xw2d18yu p, ._112118yu ul{margin:0 0 var(--ds-space-250,20px) 0}";
const _3 = "._5jhz1h3t ol, ._gxop1h3t ul{padding:0 0 0 var(--ds-space-250,20px)}";
const _2 = "._1wyb1j6v{font-size:1rem}";
const _ = "._vwz41k8s{line-height:1.5rem}";
export const Content = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_vwz41k8s _1wyb1j6v _5jhz1h3t _gxop1h3t _12ml18yu _xw2d18yu _112118yu _8agh1rkn _1foz1j6v _q7gq1j6v _zo641j6v _1wmc1k8s _zcqx1k8s _1qza1k8s _dd6hidpf _1p7uidpf _orjkidpf _xmwmidpf _1wij14y2 _1g45ugt7 _43ds14q2 _19tb1j6v _bpspni7l _p03c16c2", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}